// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11103-删除用户协议 POST /web/v1/userAgreement/delete */
export async function deleteUserAgreement(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteUserAgreementParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/userAgreement/delete", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 11101-查询用户协议 POST /web/v1/userAgreement/list */
export async function getUserAgreementPageList(
  body: API.SwimAgreementListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimUserAgreementBasicVo>(
    "/web/v1/userAgreement/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11102-新增或者是修改 POST /web/v1/userAgreement/upsert */
export async function updateUserAgreement(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateUserAgreementParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/userAgreement/upsert", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
